/**
 *   Copyright (C) Cylergie - All Rights Reserved
 * Proprietary and confidential
 * Subject to French law on copyright
 * Unauthorized copying of this file, via any medium is strictly prohibited: https://crigen.myengie.com/copyright
 * Any request for authorization of use should be addressed by email to"mvalo.bvt@engie.com" with the subject "Copyright Statement in Source Code"
 * Written in 2024
 */

/* eslint-disable */

import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import BoilerIcon from '../icons/boiler.vue';
import CogenerationIcon from '../icons/cogeneration.vue';
import DeliveryIcon from '../icons/delivery.vue';
import SiloIcon from '../icons/silo.vue';
import WoodIcon from '../icons/wood.vue';

// Definition of the theme colors
const lightColors = {
  primary: '#008CD0' /* indigo */,
  secondary: '#005288' /* bleu  */,
  accent: '#003b70' /* deep orange */,
  error: '#F44336' /* rouge */,
  info: '#00BCD4' /* cyan */,
  success: '#4CAF50' /* vert */,
  warning: '#FF9800' /* orange */,
};

const darkColors = {
  primary: '#008CD0' /* indigo */,
  secondary: '#005288' /* bleu  */,
  accent: '#003b70' /* deep orange */,
  error: '#F44336' /* rouge */,
  info: '#00BCD4' /* cyan */,
  success: '#4CAF50' /* vert */,
  warning: '#FF9800' /* orange */,
};

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
      custom: {
        boiler: BoilerIcon,
        cogeneration: CogenerationIcon,
        delivery: DeliveryIcon,
        silo: SiloIcon,
        wood: WoodIcon,
      },
    },
  },
  theme: {
    themes: {
      light: {
        colors: lightColors,
      },
      dark: {
        colors: darkColors,
      },
    },
  },
});
